module.exports = __webpack_public_path__ + "static/media/nick.1ad67b2b.png";